import axios from '@/axios'
import router from '@/router'
import {str_slug} from '@/utils/helpers'

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    login({ commit, dispatch }, payload) {
      commit('AUTH_USER', payload)
      dispatch('arrangeMenu', payload.admin)

      axios.defaults.headers.common['Authorization'] = `Bearer ${payload.accessToken}`;
      router.push('/')
    },
    logout({ commit }){
      delete axios.defaults.headers.common['Authorization'];
      commit('logoutUser');
    },
    updateUserInfo({ commit, dispatch }, user) {
      dispatch('arrangeMenu', user.admin)
      commit('UPDATE_USER_INFO', user)
    },
    arrangeMenu({commit}, user) {
      let menus = [
        {
          url: "/",
          name: "Dashboard",
          slug: "dashboard",
          icon: "HomeIcon",
        },
      ]
      if(user.role.menus) {
        user.role.menus.forEach(parent => {
          if(!parent.parentId) {
            let menu = {
              url: parent.link,
              name: parent.name,
              icon: parent.icon,
              slug: str_slug(parent.name)
            }
            let submenu = []
            if(parent.children) {
              parent.children.forEach(child => {
                const childSlug = str_slug(child.name)
                submenu.push({
                  url: child.link,
                  name: child.name,
                  slug: childSlug,
                  isHidden: childSlug === 'campaign-setting'
                })
              })
            }

            if(submenu.length) menu.submenu = submenu
            menus.push(menu)
          }
        })
      }
      commit('set_menus', menus)
    },

    getListPlatform({commit}) {
      return axios.get('/misc/campaign-platforms')
        .then(res => {
          const { data } = res.data
          commit('UPDATE_PLATFORM_LIST', data)
        })
    }
}

export default actions
